var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirstPlace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000003756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6878 21.5066C6.96601 21.5066 6.38088 20.9215 6.38088 20.1997V17.5859L7.6878 18.3327V21.5066Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79081 22.3849C8.51529 22.2471 8.34125 21.9655 8.34125 21.6575V18.7061L10.3833 19.873L11.7672 20.6638L12.9107 20.0103L15.3315 18.627V21.7145C15.3315 21.9921 15.1899 22.2505 14.956 22.3999L12.6508 23.8721C12.4096 24.0262 12.1053 24.0421 11.8494 23.9141L8.79081 22.3849Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8465 21.5066C16.4807 21.5066 16.9948 20.9925 16.9948 20.3583V17.6765L15.8465 18.3327V21.5066Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.43831 4.51252C2.93153 4.80211 2.61877 5.34104 2.61877 5.92472V15.4361L6.38088 17.5859L7.6878 18.3327L8.34125 18.7061L10.3833 19.873L11.7672 20.6638L20.096 15.9044C20.6028 15.6148 20.9155 15.0759 20.9155 14.4922V5.92472C20.9155 5.34104 20.6028 4.80211 20.096 4.51252L12.5741 0.214303C12.0741 -0.0714346 11.4602 -0.0714342 10.9602 0.214304L3.43831 4.51252Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6878 21.5066C6.96601 21.5066 6.38088 20.9215 6.38088 20.1997V17.5859L7.6878 18.3327V21.5066Z",
    fill: "#D9AE67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79081 22.3849C8.51529 22.2471 8.34125 21.9655 8.34125 21.6575V18.7061L10.3833 19.873L10.9602 20.2027C11.4603 20.4884 12.0741 20.4884 12.5742 20.2027L12.9107 20.0103L15.3315 18.627V21.7145C15.3315 21.9921 15.1899 22.2505 14.956 22.3999L12.6508 23.8721C12.4096 24.0262 12.1053 24.0421 11.8494 23.9141L8.79081 22.3849Z",
    fill: "#D9AE67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8465 21.5066C16.4807 21.5066 16.9948 20.9925 16.9948 20.3583V17.6765L15.8465 18.3327V21.5066Z",
    fill: "#D9AE67"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 33",
    d: "M5.23267 12.9968V7.42009C5.23267 6.71757 5.60126 6.06655 6.20367 5.70511L10.7382 2.98437C11.3716 2.60435 12.1629 2.60435 12.7962 2.98437L17.3308 5.70511C17.9332 6.06655 18.3018 6.71757 18.3018 7.42009V12.9968C18.3018 13.6993 17.9332 14.3503 17.3308 14.7118L12.7962 17.4325C12.1629 17.8125 11.3716 17.8125 10.7382 17.4325L6.20367 14.7118C5.60126 14.3503 5.23267 13.6993 5.23267 12.9968Z",
    fill: "url(#paint0_linear_4613_18169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M12.8665 7.07291V12.9287H11.6063V8.10511H11.5656L9.9386 8.98005V8.0079L11.6675 7.07291H12.8665Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4613_18169",
    x1: 17.2582,
    y1: 4.87697,
    x2: 7.0106,
    y2: 15.1246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#885F0B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPlace);
export default __webpack_public_path__ + "static/media/first-place.f3fa026fbf67b1eb737a6f5dec4d5c26.svg";
export { ForwardRef as ReactComponent };